import { jsx as _jsx } from "react/jsx-runtime";
import wingUrl from '../../../assets/gems/wing.svg?inline';
export function Wing({ ...props }) {
    return _jsx("img", { ...props, src: wingUrl, alt: 'WingImage' });
}
